import type { Landmark } from '../types';

/**
 * Live overlay landmarks must stay aligned with MediaPipe's 33 indices: the drawers read ear,
 * shoulder, hip, knee, ankle by `IDX`. Removing low-visibility points (the far-side chain in a
 * lateral view) shifted every later index, so the skeleton was drawn on the wrong body parts.
 * Blank them in place instead; the drawers already skip null points.
 */
export function maskLowVisibilityLandmarks(
  landmarks: ReadonlyArray<Landmark | null>,
  threshold: number,
): Array<Landmark | null> {
  return landmarks.map((lm) => (lm && (lm.visibility ?? 0) > threshold ? lm : null));
}

/** Scale video-pixel landmarks to the displayed video size, keeping blanks blank. */
export function scaleLandmarks(
  landmarks: ReadonlyArray<Landmark | null>,
  scaleX: number,
  scaleY: number,
): Array<Landmark | null> {
  return landmarks.map((lm) => (lm ? { ...lm, x: lm.x * scaleX, y: lm.y * scaleY } : null));
}
